import { useMemo } from 'react';
import { flattened } from '@app/utils/utils';
import { useIntl } from 'react-intl';

export const useIntlMessage = (...idList) => {
  const intl = useIntl();

  const intlMessages = useMemo(() => {
    const flattenedKeys = flattened(idList);
    return flattenedKeys.map(key =>
      typeof key === 'object' ? intl.formatMessage({ id: key.id }, { ...key.values }) : intl.formatMessage({ id: key }),
    );
  }, [intl, idList]);

  return intlMessages;
};

export default useIntlMessage;
